var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0ZM24.2581 11.7631C24.2706 11.9462 24.2706 12.1294 24.2706 12.3138C24.2706 17.9444 19.9844 24.4375 12.1469 24.4375V24.4344C9.83187 24.4375 7.56437 23.7738 5.61625 22.5238C5.9525 22.5638 6.29125 22.5844 6.63062 22.585C8.54937 22.5869 10.4131 21.9431 11.9219 20.7575C10.0994 20.7231 8.49937 19.5344 7.94125 17.7981C8.58 17.9212 9.23812 17.8962 9.865 17.725C7.87687 17.3237 6.4475 15.5769 6.44688 13.5487V13.4944C7.03938 13.825 7.7025 14.0075 8.38062 14.0275C6.50812 12.7775 5.93062 10.2869 7.06125 8.34C9.225 11.0019 12.4169 12.62 15.8431 12.7919C15.4994 11.3119 15.9688 9.76125 17.0756 8.72062C18.7913 7.10687 21.4906 7.19 23.1044 8.90563C24.0588 8.7175 24.9737 8.3675 25.81 7.87125C25.4919 8.85812 24.8263 9.69562 23.9369 10.2281C24.7812 10.1281 25.6063 9.9025 26.3838 9.5575C25.8119 10.4131 25.0919 11.16 24.2581 11.7631Z",
    fill: "#21FFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.861deb4caed39696f5de509ca4cec7ad.svg";
export { ForwardRef as ReactComponent };